import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-visualizar-logs-proposta',
  templateUrl: './visualizar-logs-proposta.component.html',
  styleUrls: ['./visualizar-logs-proposta.component.scss'],
})
export class VisualizarLogsPropostaComponent implements OnChanges {
  @Input() listaHistoricoProposta: any[] = [];
  historicoPropostaFiltrada: any[] = [];

  //reagir à mudança do input usando o lifecycle hook ngOnChanges
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listaHistoricoProposta'] && this.listaHistoricoProposta) {
      this.historicoPropostaFiltrada = this.listaHistoricoProposta.flatMap(
        item =>
          Array.isArray(item.dadosBeneficiario?.dealLeads)
            ? item.dadosBeneficiario.dealLeads.filter(
                (lead: any) => lead.step !== -1,
              )
            : [],
      );
    }
  }

  getTimelineBackground(index: number): string {
    const backgrounds = [
      'linear-gradient(120deg, rgba(255, 255, 255, 0.7), rgba(147, 197, 253, 0.3))',
      'linear-gradient(120deg, rgba(255, 255, 255, 0.7), rgba(46, 39, 157, 0.2))',
      'linear-gradient(120deg, rgba(255, 255, 255, 0.7), rgba(147, 197, 253, 0.3))',
      'linear-gradient(120deg, rgba(255, 255, 255, 0.7), rgba(110, 231, 183, 0.3))',
      'linear-gradient(120deg, rgba(255, 255, 255, 0.7), rgba(46, 39, 157, 0.1))',
    ];

    return backgrounds[index % backgrounds.length];
  }
}
